export type Component = {
  title: string;
  subtitle?: string;
  cover: string;
  coverDark?: string;
  link: string;
  tag?: string;
};

const proComponentsList: Component[] = [
  {
    cover: 'https://gw.alipayobjects.com/zos/antfincdn/4n5H%24UX%24j/bianzu%2525204.svg',
    link: 'https://procomponents.ant.design/components/layout',
    subtitle: '高级布局',
    title: 'ProLayout',
    tag: 'https://gw.alipayobjects.com/zos/antfincdn/OG4ajVYzh/bianzu%2525202.svg',
  },
  {
    cover: 'https://gw.alipayobjects.com/zos/antfincdn/mStei5BFC/bianzu%2525207.svg',
    link: 'https://procomponents.ant.design/components/form',
    subtitle: '高级表单',
    title: 'ProForm',
    tag: 'https://gw.alipayobjects.com/zos/antfincdn/OG4ajVYzh/bianzu%2525202.svg',
  },
  {
    cover: 'https://gw.alipayobjects.com/zos/antfincdn/AwU0Cv%26Ju/bianzu%2525208.svg',
    link: 'https://procomponents.ant.design/components/table',
    subtitle: '高级表格',
    title: 'ProTable',
    tag: 'https://gw.alipayobjects.com/zos/antfincdn/OG4ajVYzh/bianzu%2525202.svg',
  },
  {
    cover: 'https://gw.alipayobjects.com/zos/antfincdn/H0%26LSYYfh/bianzu%2525209.svg',
    link: 'https://procomponents.ant.design/components/descriptions',
    subtitle: '高级定义列表',
    title: 'ProDescriptions',
    tag: 'https://gw.alipayobjects.com/zos/antfincdn/OG4ajVYzh/bianzu%2525202.svg',
  },
  {
    cover: 'https://gw.alipayobjects.com/zos/antfincdn/uZUmLtne5/bianzu%2525209.svg',
    link: 'https://procomponents.ant.design/components/list',
    subtitle: '高级列表',
    title: 'ProList',
    tag: 'https://gw.alipayobjects.com/zos/antfincdn/OG4ajVYzh/bianzu%2525202.svg',
  },
  {
    cover: 'https://gw.alipayobjects.com/zos/antfincdn/N3eU432oA/bianzu%2525209.svg',
    link: 'https://procomponents.ant.design/components/editable-table',
    subtitle: '可编辑表格',
    title: 'EditableProTable',
    tag: 'https://gw.alipayobjects.com/zos/antfincdn/OG4ajVYzh/bianzu%2525202.svg',
  },
];

export default proComponentsList;
